export default "__VITE_ASSET__B3arJII3__"